import { User } from '@/interfaces/user'
import axios from 'axios'

export function updateContact(user: User) {
  const endpoint = process.env.VUE_APP_UPDATE_CONTACT_ENDPOINT

  return axios.post(endpoint, user)
    .then(response => response.data)
}
